/**
 * This middleware sets the page layout based on the platform or device.
 */
export default defineNuxtRouteMiddleware(() => {
  const { isWebView } = usePlatform()
  const { $device } = useNuxtApp()

  setPageLayout(isWebView.value || ($device as { isMobile: boolean }).isMobile ? 'minimal' : 'default')
})
